import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["fill"];
import React from 'react';
var SVG_PATHS = [{
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M17.8287 10.7565L15.8667 10.3683C15.9539 9.92738 16 9.47006 16 9C16 8.52994 15.9539 8.07262 15.8667 7.63168L17.8287 7.24354C17.9411 7.81162 18 8.39893 18 9C18 9.60107 17.9411 10.1884 17.8287 10.7565ZM16.4841 3.99946L14.8222 5.1121C14.3105 4.34788 13.6521 3.68948 12.8879 3.17785L14.0005 1.51591C14.982 2.17298 15.827 3.018 16.4841 3.99946ZM10.7565 0.171306L10.3683 2.13328C9.92738 2.04605 9.47006 2 9 2C8.52994 2 8.07262 2.04605 7.63168 2.13328L7.24354 0.171307C7.81163 0.0589225 8.39893 0 9 0C9.60107 0 10.1884 0.0589224 10.7565 0.171306ZM3.99946 1.51591L5.1121 3.17785C4.34788 3.68948 3.68948 4.34788 3.17785 5.1121L1.51591 3.99946C2.17298 3.018 3.018 2.17298 3.99946 1.51591ZM0.171306 7.24354C0.0589224 7.81163 0 8.39893 0 9C0 9.60107 0.0589225 10.1884 0.171306 10.7565L2.13328 10.3683C2.04605 9.92738 2 9.47006 2 9C2 8.52994 2.04605 8.07262 2.13328 7.63168L0.171306 7.24354ZM1.51591 14.0005L3.17785 12.8879C3.68948 13.6521 4.34788 14.3105 5.1121 14.8222L3.99946 16.4841C3.018 15.827 2.17298 14.982 1.51591 14.0005ZM7.24354 17.8287L7.63168 15.8667C8.07262 15.9539 8.52994 16 9 16C9.47006 16 9.92738 15.9539 10.3683 15.8667L10.7565 17.8287C10.1884 17.9411 9.60107 18 9 18C8.39893 18 7.81163 17.9411 7.24354 17.8287ZM14.0005 16.4841C14.982 15.827 15.827 14.982 16.4841 14.0005L14.8222 12.8879C14.3105 13.6521 13.6521 14.3105 12.8879 14.8222L14.0005 16.4841Z'
}];
export var DEFAULT_FILL_UNASSESSED = '#C7CDD1';
export var UnassessedIcon = function UnassessedIcon(_ref) {
  var _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? DEFAULT_FILL_UNASSESSED : _ref$fill,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    id: "unassessed",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Unassessed"
  }, props), SVG_PATHS.map(function (pathProps, index) {
    return /*#__PURE__*/React.createElement("path", Object.assign({
      key: index
    }, pathProps));
  }));
};
export var unassessedIconSvgPaths = SVG_PATHS.map(function (p) {
  return "<path fill-rule=\"".concat(p.fillRule, "\" d=\"").concat(p.d, "\"/>");
}).join('');